import React from 'react'
import { string, bool  } from 'prop-types'

import intl from 'react-intl-universal'

import Typography from 'components/atoms/Typography'

import LikeButton from 'components/molecules/LikeButton'
import { SVGIcon } from 'components/qstrap'
import getMajorIcon from 'utils/getMajorIcon'
import triggerEvent from 'utils/dataLayer'

const StickyBottomMajorCareer = ({
  title,
  iconBg,
  iconName,
  likeStatus,
  likeTarget,
  kind,
}) => (
  <div className="sticky-bottom-nav__wrapper">
    <div className="sticky-bottom-nav__icon">
      {kind === 'studyFields' && iconName !== 'common-course' ? (
        getMajorIcon(iconName, 24, 24)
      ) : (
        <SVGIcon size="sm" name={iconName}/>
      )}
    </div>
    <Typography className="sticky-bottom-nav__title" component="h6" variant="body" fontWeight="bold">
      { title }
    </Typography>
    <LikeButton
      active={likeStatus}
      kind={kind}
      targetId={likeTarget}
      forDetailPage
      complete
      useNewIcon
      handleClick={() => triggerEvent('career_favourite', {
        career_name: title,
        favorite_button_location: 'sticky',
        page_location: window.location.pathname,
      })}
    >
      <span>
        {likeStatus ? intl.get('common.remove_from_favorite') : intl.get('common.add_to_favorite')}
      </span>
    </LikeButton>
    <style jsx>
      {`
        .sticky-bottom-nav {
          :global(&__wrapper) {
            display: flex;
            align-items: center;
            @media screen and (max-width: 767px) {
              display: none;
            }
          }
          :global(&__icon) {
            @media screen and (min-width: 768px) {
              width: 48px;
              height: 48px;
              background-color: ${iconBg || '#0fc3c4'};
              border-radius: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              :global(svg) {
                fill: #fff;
                width: 24px;
                height: 24px;
              }
            }
          }
          :global(&__title) {
            flex-grow: 1;
            padding-left: 20px;
          }
        }
      `}
    </style>
  </div>
)

StickyBottomMajorCareer.propTypes = {
  title: string.isRequired,
  iconBg: string,
  iconName: string,
  likeStatus: bool,
  likeTarget: string,
  kind: string,
}
export default StickyBottomMajorCareer
